import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modals/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnContactList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import { capitalizeFirstLetter } from 'src/helpers/text-format'
import useToastMessage from 'src/helpers/toast-message'

const ContactList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [contactList, setContactList] = useState([]);
  const [contactListCount, setContactListCount] = useState(0);
  const [contactListPerPage, setContactListPerPage] = useState(10);
  const [activeContactListPage, setActiveContactListPage] = useState(1);
  const [searchContactListFilter, setSearchContactListFilter] = useState("");
  const [columnContactListSorter, setColumnContactListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchContactListFilter,
      limit: contactListPerPage,
      offset: contactListPerPage * activeContactListPage - contactListPerPage,
      sort:
        (columnContactListSorter &&
          `${columnContactListSorter.column}%${columnContactListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllContacts(queries);
  }, [
    searchContactListFilter,
    contactListPerPage,
    activeContactListPage,
    columnContactListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveContactListPage(1)
    setSearchContactListFilter(search);
  }

  const fetchAllContacts = (queries) => {
    Axios({
      method: "get",
      url: `/api/whatsapp/v1/contact?${queries}`,
    })
      .then(({ data }) => {
        if (data) {
          let tempContactList = data?.value
          tempContactList = tempContactList?.map((d) => ({
            ...d,
            profile_name: d?.profile_name ? `${capitalizeFirstLetter(d?.profile_name)}` : '',
            company_name: d?.company_name ? d?.company_name : '-',
          }))
          setContactList(tempContactList);
          if (activeContactListPage === 1) {
            setContactListCount(data?.count);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/whatsapp/v1/contact/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.status == 'success') {
          setShowConfirmDelete({ show: false, item: {} })
          showSuccess('Contact has been successfully deleted')
          fetchAllContacts()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/contacts/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`Contact ${showConfirmDelete?.item?.profile_name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/contacts/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Contact
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Contact List</h4>}
        bodyContent={
          <AppTable
            contactListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnContactList}
            tableContent={contactList}
            contentPerPage={contactListPerPage}
            activeContentPage={activeContactListPage}
            contentCount={contactListCount}
            searchContentFilter={searchContactListFilter}
            setActiveContentPage={setActiveContactListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setContactListPerPage}
            setColumnContentSorter={setColumnContactListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default ContactList